import { cx } from "@frontend/components/ui";

/** Star (Serious) / neon bolt (Priority) — replaces text labels in inbox & updates. */
export function BoostTierIcon({
  tier,
  className,
}: {
  tier: string;
  className?: string;
}) {
  if (tier === "serious") {
    return (
      <span
        className={cx(
          "inline-flex shrink-0 items-center justify-center text-boost-serious",
          className,
        )}
        title="Serious"
        aria-label="Serious"
      >
        <svg viewBox="0 0 20 20" fill="currentColor" className="size-3.5">
          <path
            fillRule="evenodd"
            d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.39c-.833.068-1.172 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.494c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.636-.544.297-1.583-.536-1.65l-4.752-.391-1.831-4.401Z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    );
  }

  if (tier === "priority") {
    return (
      <span
        className={cx("boost-bolt-neon inline-flex shrink-0 items-center justify-center", className)}
        title="Priority"
        aria-label="Priority"
      >
        <svg viewBox="0 0 20 20" fill="currentColor" className="size-3.5">
          <path d="M11.983 1.904a.75.75 0 0 0-1.292-.657l-7.25 8.5A.75.75 0 0 0 4 11h4.25l-.733 6.596a.75.75 0 0 0 1.292.657l7.25-8.5A.75.75 0 0 0 15.5 8.5h-4.25l.733-6.596Z" />
        </svg>
      </span>
    );
  }

  return null;
}
